module.exports = __webpack_public_path__ + "static/OR2-bb39ffc3330d0734bbac59140b6106b2.jpg";